/* eslint-disable */
import { sentryInit } from './libs/sentry';
import { isSafariInit } from './libs/isSafari';
import { checkTranslations } from './utils/translations'

import './libs/client-ids';
import '@skillbox/form-autocomplete';
import '@skillbox/cookie-sync';
import './libs/user-sesson';
import './libs/utm-service';

import { customAnalyticsInit } from './libs/customAnalytics/index';
import { mindboxInit } from './libs/mindbox';
import { growthbookInit } from './libs/growthbook';
import { initVkAutoLead } from './libs/autolead';

import { formsInit } from './components/forms';
import { accordionInit } from './components/accordion';
import { UiSpoilerVanillaInit } from '@skillbox/front-box/dist/InteractiveElements/UiSpoiler/UiSpoilerVanilla';
import { gtmAnalyticHandlersInit } from './components/gtm-events';
import { slidersInit } from './components/defaultSlider';
import { tooltipsInit } from './components/tooltip';
import { buttonsHandlersInit } from './components/button-actions';
import { videoModalInit } from './components/UiVideoModal';
import { addBackButton } from './components/UiBackButton/UiBackButton';
import { abInit } from './libs/ab-testing';
import { videoObserverInit } from './utils/lazyload-video';
import { initVideoWidget } from './components/VideoWidget/VideoWidget';

// Записываем document.referrer до редиркекта в ВК для пуша аналитики pageview в gtmAnalyticHandlersInit()
if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('savedReferrer') === null) {
  sessionStorage.setItem('savedReferrer', document.referrer);
}

sentryInit();
abInit();
isSafariInit();
checkTranslations();
customAnalyticsInit();
mindboxInit();
growthbookInit();
initVkAutoLead();
addBackButton();
formsInit();
accordionInit();
UiSpoilerVanillaInit();
gtmAnalyticHandlersInit();
slidersInit();
tooltipsInit();
buttonsHandlersInit();
videoModalInit();
videoObserverInit();
initVideoWidget();
/* eslint-enable */
